export default [
  {
    path: '/davReport/',
    name: 'dav-report',
    title: 'DAV report',
    component: () => import('../views/DavReportView.vue'),
    redirect: { name: 'dav-report-listar' },
    children: [
      {
        path: 'welcome',
        name: 'dav-report-listar',
        component: () => import('../views/DavReportWelcomeView.vue'),
        meta: { title: 'Listar DAV reports' },
      },
      {
        path: 'add',
        name: 'dav-report-cadastrar',
        component: () => import('../views/DavReportFormView.vue'),
        meta: { title: 'Cadastrar DAV report' },
      },
      {
        path: ':id',
        name: 'dav-report-editar',
        meta: { title: 'Editar DAV report' },
        component: () => import('../views/DavReportFormView.vue'),
      },
    ],
  },
];
